import {ContentMainProps} from './ContentMainProps.interface';

/**
 * 콘텐츠홈의 전체 레이아웃에 해당하는 콘텐츠 메인입니다.
 */
export function ContentMain({children, ...props}: ContentMainProps) {
  return <div {...props}>{children}</div>;
}
